package kz.dentalcrm.app.core.ui.icons.defaulticons

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Round
import androidx.compose.ui.graphics.StrokeJoin
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import kotlin.Unit
import kz.dentalcrm.app.core.ui.icons.DefaultIcons

public val DefaultIcons.Tenge: ImageVector
    get() {
        if (_tenge != null) {
            return _tenge!!
        }
        _tenge = Builder(name = "Tenge", defaultWidth = 800.0.dp, defaultHeight = 800.0.dp,
                viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0x00000000)), stroke = SolidColor(Color(0xFF000000)),
                    strokeLineWidth = 2.0f, strokeLineCap = Round, strokeLineJoin =
                    StrokeJoin.Companion.Round, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(12.0f, 19.0f)
                verticalLineTo(9.0f)
                moveTo(6.0f, 9.0f)
                horizontalLineTo(18.0f)
                moveTo(6.0f, 5.0f)
                horizontalLineTo(18.0f)
            }
        }
        .build()
        return _tenge!!
    }

private var _tenge: ImageVector? = null
